import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cnaeReadAction from './cnaeRead.action.json' with { type: 'json' }

const cnaeReadDefinition = defineReadAutoAction(cnaeReadAction, 'cnae')

export default cnaeReadDefinition
